/**
 * @file Components/SEO/MetaTags.jsx
 * @description SEO meta tags component using React Helmet. Sets page title,
 * description, Open Graph, and Twitter Card meta tags for each page.
 */

import React from 'react';
import { Helmet } from 'react-helmet';

const MetaTags = ({ 
  title, 
  description, 
  keywords,
  ogImage = '/assets/Asset 2Nikaba travels - Ci-1.png',
  ogType = 'website',
  canonical
}) => {
  const siteUrl = 'https://nikabatravels.com';
  const fullUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title ? `${title} | Nikaba Travels` : 'Nikaba Travels - Best Inbound and Outbound Tour Operator in India'}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="Nikaba Travels" />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${siteUrl}${ogImage}`} />

      {/* Additional SEO Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Nikaba Travels" />
    </Helmet>
  );
};

export default MetaTags; 